import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { PARK_DOCUMENT } from "./apiRoutes";

const mutateAddParkDoc = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${PARK_DOCUMENT}/park`, data);
};

const useAddParkDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddParkDoc,
    ...queryParams,
  });

export default useAddParkDocMutation;
